import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { useEffect, useRef } from 'react';
import { DeleteOutlineRounded } from '@mui/icons-material';
import { ActionResponseStatusAi } from '@/ai/enum/action-response-status-ai';
import { useAndie } from '@/providers/andie-provider';
import { useLocation } from 'react-router-dom';

type ActionResponse = { id: string };
type ActionArgs = { postId: string };

export type AndieDeletePostProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieDeletePost = (props: AndieDeletePostProps) => {
    const { t } = useTranslation();
    const { helpers } = useAndie();
    const executingSteps = useRef<number>(0);
    const pathname = useLocation().pathname;

    useEffect(() => {
        if (props.status === ActionResponseStatusAi.EXECUTING) {
            executingSteps.current += 1;
        }

        if (
            props.status === ActionResponseStatusAi.COMPLETE &&
            props.result?.id &&
            executingSteps.current > 0
        ) {
            helpers.removePost(props.result.id);

            const openedPostId = props.args?.postId;
            if (openedPostId && pathname.endsWith('post/' + openedPostId)) {
                helpers.navigateBackFromPost();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.status]);

    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.delete-post.title')}
            icon={<DeleteOutlineRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.delete-post.loading')]}
            completeMessage={() => t('andie.tool.delete-post.complete')}
            {...props}
        />
    );
};

export default AndieDeletePost;
